import React from 'react';
import { ICON_PATHS, WORDMARK_PATHS } from '../common/NexumiLogo';

/**
 * Pamja statike e skenës: vendmbajtës gjatë ngarkimit të Three.js dhe rezerva
 * e përhershme kur WebGL mungon ose dështon. I njëjti kompozim si skena 3D —
 * telefoni përpara, paneli «Hyrje / Dalje» prapa — në gjendjen përfundimtare
 * të ciklit: Drita «Prezent», kërkesa e pushimit «Aprovuar», njoftimi.
 * `text` = `canvas` nga `presentationContent.js`, në gjuhën e faqes.
 */

const ROWS = [
  { i: 'AK', n: 'Arben Krasniqi', d: 0, s: 'present', t: '07:46' },
  { i: 'ES', n: 'Elira Shahini', d: 1, s: 'present', t: '07:52' },
  { i: 'DM', n: 'Drita Morina', d: 2, s: 'present', t: '08:00' },
  { i: 'VG', n: 'Valon Gashi', d: 3, s: 'onLeave', t: '—' },
];

const TONE = {
  present: { bg: '#ECFDF5', ink: '#047857', line: '#6EE7B7' },
  onLeave: { bg: '#F0F9FF', ink: '#0369A1', line: '#7DD3FC' },
};

function Chip({ x, y, label, tone, w = 62 }) {
  const c = TONE[tone];
  return (
    <g>
      <rect x={x} y={y} width={w} height="17" rx="4.5" fill={c.bg} stroke={c.line} />
      <text x={x + w / 2} y={y + 12} fontSize="9" fontWeight="600" fill={c.ink} textAnchor="middle">{label}</text>
    </g>
  );
}

function Check({ cx, cy, r }) {
  return (
    <g>
      <circle cx={cx} cy={cy} r={r} fill="#10B981" />
      <path d={`M${cx - r * 0.42} ${cy} l${r * 0.32} ${r * 0.3} l${r * 0.56} ${-r * 0.62}`} stroke="#fff" strokeWidth={r * 0.2} fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  );
}

export default function HeroStatic({ hidden = false, text }) {
  return (
    <svg
      className={`nxp-static${hidden ? ' is-hidden' : ''}`}
      viewBox="0 0 640 520"
      aria-hidden="true"
      focusable="false"
      fontFamily="Inter, -apple-system, sans-serif"
    >
      <defs>
        <filter id="nxp-soft" x="-20%" y="-20%" width="140%" height="160%">
          <feDropShadow dx="2" dy="12" stdDeviation="14" floodColor="#10283A" floodOpacity="0.18" />
        </filter>
      </defs>

      {/* Paneli i menaxherit */}
      <g filter="url(#nxp-soft)">
        <rect x="150" y="62" width="478" height="300" rx="10" fill="#fff" stroke="#DCE4E8" />
      </g>
      <line x1="252" y1="62" x2="252" y2="362" stroke="#E5E7EB" />
      <g transform="translate(164 76) scale(0.048)">
        {ICON_PATHS.map((d) => <path key={d} d={d} fill="#4893A5" />)}
        {WORDMARK_PATHS.map((d) => <path key={d} d={d} fill="#303D50" />)}
      </g>
      {text.nav.map((label, i) => (
        <g key={label}>
          {i === 1 && <rect x="157" y={104 + i * 22} width="88" height="18" rx="4" fill="#E6F4F8" />}
          <text x="166" y={116 + i * 22} fontSize="8" fontWeight={i === 1 ? 600 : 500} fill={i === 1 ? '#256878' : '#4B5563'}>
            {label.length > 18 ? `${label.slice(0, 17)}…` : label}
          </text>
        </g>
      ))}
      <line x1="252" y1="90" x2="628" y2="90" stroke="#E5E7EB" />
      <text x="618" y="80" fontSize="8" fill="#6B7280" textAnchor="end">{text.sampleData}</text>
      <text x="266" y="118" fontSize="15" fontWeight="700" fill="#111827">{text.live}</text>
      <text x="266" y="133" fontSize="8" fill="#6B7280">{text.liveDate}</text>
      {text.groups.map((label, i) => (
        <g key={label}>
          <rect x={266 + i * 120} y="144" width="112" height="38" rx="6" fill="#F9FAFB" stroke="#E5E7EB" />
          <text x={274 + i * 120} y="158" fontSize="8" fill="#4B5563">{label}</text>
          <text x={274 + i * 120} y="176" fontSize="14" fontWeight="700" fill="#111827">{[3, 0, 1][i]}</text>
        </g>
      ))}
      <rect x="266" y="192" width="352" height="18" rx="5" fill="#F9FAFB" />
      {ROWS.map((r, i) => (
        <g key={r.i}>
          <circle cx="280" cy={226 + i * 34} r="8" fill="#E6F4F8" />
          <text x="280" y={229 + i * 34} fontSize="6.5" fontWeight="700" fill="#256878" textAnchor="middle">{r.i}</text>
          <text x="294" y={229 + i * 34} fontSize="9" fontWeight="600" fill="#111827">{r.n}</text>
          <text x="410" y={229 + i * 34} fontSize="8.5" fill="#4B5563">{text.depts[r.d]}</text>
          <Chip x={486} y={217 + i * 34} label={r.s === 'present' ? text.present : text.onLeave} tone={r.s} />
          <text x="610" y={229 + i * 34} fontSize="9" fontWeight="600" fill="#374151" textAnchor="end">{r.t}</text>
        </g>
      ))}

      {/* Kërkesa e pushimit, e aprovuar */}
      <g filter="url(#nxp-soft)">
        <rect x="380" y="282" width="236" height="96" rx="10" fill="#fff" stroke="#E5E7EB" />
      </g>
      <text x="394" y="302" fontSize="8" fill="#6B7280">{text.request}</text>
      <text x="394" y="317" fontSize="12" fontWeight="700" fill="#111827">{text.annualLeave}</text>
      <text x="394" y="336" fontSize="8.5" fill="#4B5563">Drita Morina · {text.leaveDates}</text>
      <rect x="394" y="346" width="208" height="22" rx="6" fill="#ECFDF5" />
      <Check cx={406} cy={357} r={6} />
      <text x="418" y="360" fontSize="8.5" fontWeight="600" fill="#047857">{text.approvedBy}</text>

      {/* Telefoni */}
      <g filter="url(#nxp-soft)">
        <rect x="34" y="104" width="168" height="345" rx="26" fill="#3A414B" />
      </g>
      <rect x="40" y="110" width="156" height="333" rx="21" fill="#fff" />
      <rect x="98" y="117" width="40" height="11" rx="5.5" fill="#05080B" />
      <text x="54" y="125" fontSize="7" fontWeight="600" fill="#111827">08:00</text>
      <text x="52" y="152" fontSize="10" fontWeight="700" fill="#111827">{text.scanPresence}</text>
      <text x="52" y="164" fontSize="7.5" fill="#6B7280">Drita Morina</text>
      <rect x="50" y="198" width="136" height="30" rx="7" fill="#ECFDF5" />
      <Check cx={64} cy={213} r={7} />
      <text x="76" y="211" fontSize="8" fontWeight="700" fill="#111827">{text.recorded}</text>
      <text x="76" y="221" fontSize="6.5" fill="#047857">{text.actions[0]} · 08:00</text>
      <text x="52" y="250" fontSize="9" fontWeight="700" fill="#111827">{text.myLeaves}</text>
      <rect x="50" y="258" width="136" height="62" rx="7" fill="#fff" stroke="#6EE7B7" />
      <text x="60" y="276" fontSize="8.5" fontWeight="700" fill="#111827">{text.annualLeave}</text>
      <text x="60" y="288" fontSize="6.5" fill="#6B7280">{text.leaveDates}</text>
      <Chip x={60} y={296} label={text.approved} tone="present" w={58} />
      <rect x="94" y="433" width="48" height="3" rx="1.5" fill="#1F2937" />

      {/* Njoftimi */}
      <g filter="url(#nxp-soft)">
        <rect x="150" y="410" width="236" height="44" rx="22" fill="#fff" stroke="#D9E2E7" />
      </g>
      <Check cx={174} cy={432} r={10} />
      <text x="192" y="436" fontSize="11" fontWeight="600" fill="#111827">{text.toastLeave}</text>
    </svg>
  );
}
